import CallToAction from './CallToAction';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import formatPrismicData from '../../hocs/formatPrismicData';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import withCountry from '../../hocs/withCountry';

const enhance = compose(
  formatPrismicData,
  withCountry,
  withProps(props => ({
    ctaLink: localiseUrl(props.country, props.ctaLink)
  }))
);

export default enhance(CallToAction);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CallToAction/index.js